import { UserAccess } from '@fullstory/proto/fs/services/dx-objects';
import {
  AppDispatch,
  fullstorySelectors,
  getSavedSpacesById,
  getSpacesAccessById,
  SpaceRequestActions,
} from '@fullstory/redux';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useSpace = (id: string, enabled: boolean = false) => {
  const orgId = useSelector(fullstorySelectors.getOrgId);
  const spacesById = useSelector(getSavedSpacesById);
  const spaceAccessById = useSelector(getSpacesAccessById);
  const [error, setError] = useState(false);

  const spaceAccess =
    spaceAccessById?.[id] ||
    ({
      canRead: false,
      canWrite: false,
      canDelete: false,
      canUpdate: false,
    } as UserAccess);

  const dispatch = useDispatch<AppDispatch>();
  const fetch = useCallback(() => {
    if (enabled && id) {
      dispatch(
        SpaceRequestActions.getSpace(
          {
            orgId,
            id,
          },
          true,
        ),
      )
        .then(() => setError(false))
        .catch(() => setError(true));
    }
  }, [dispatch, enabled, id, orgId]);

  useEffect(() => {
    fetch();
  }, [dispatch, enabled, fetch, id, orgId]);

  return { space: spacesById[id], spaceAccess, error, refetch: fetch };
};
